<header role="banner">
  <div class="header-traducao">
    <app-drop-down (idiomaAlterado)="onIdiomaAlterado($event)"></app-drop-down>
  </div>
  <nav class="header-botoes" aria-label="Redes Sociais">
    <a id="github-link" href="https://github.com/renanfochetto" target="_blank" rel="noopener noreferrer" aria-label="Perfil no GitHub">
      <img class="botao-logo-github" src="/assets/buttons/github.png" alt="Logo do Github com link para o Perfil de Renan Fochetto">
    </a>
    <a id="linkedin-link" href="https://www.linkedin.com/in/renan-fochetto-744654184/" target="_blank" rel="noopener noreferrer" aria-label="Perfil no Linkedin">
      <img class="botao-logo-linkedin" src="assets/buttons/linkedin.png" alt="Logo do Linkedin com link para o Perfil de Renan Fochetto">
    </a>
  </nav>
</header>
